module.exports = __webpack_public_path__ + "img/img-02.d313d5ff.png";